// extracted by mini-css-extract-plugin
export default {"keys__key":"lsf-keys__key","keys__key-group":"lsf-keys__key-group","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630374472
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  